import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import { Form, PrimaryButton, FieldTextInput, IconSpinner } from '../../components';

import css from './ClaimForm.module.css';
import { Link } from 'react-router-dom';

const CalimForm = props => {
  return (
    <FinalForm
      initialValues={props.initialValues}
      {...props}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          handleSubmit,
          handleOnChangeIsAgreed,
          isAgreed,
          inProgress,
          invalid,
          intl,
          admin,
          wineryOwner,
        } = fieldRenderProps;
        // email
        const emailLabel = intl.formatMessage({
          id: 'ClaimForm.emailLabel',
        });
        const emailPlaceholder = intl.formatMessage({
          id: 'ClaimForm.emailPlaceholder',
        });
        const emailRequiredMessage = intl.formatMessage({
          id: 'ClaimForm.emailRequired',
        });
        const emailRequired = validators.required(emailRequiredMessage);

        const isAdmin = validators.chackeIsAdminOrOwner(admin, "You are an admin, please login with that email you'de like to give it a winery owner role");
        const isOwner = validators.chackeIsAdminOrOwner(wineryOwner, "You are already owner of a winery,if you'de like to claim for this winery, please login with another email");

        const emailInvalidMessage = intl.formatMessage({
          id: 'ClaimForm.emailInvalid',
        });
        const emailValid = validators.emailFormatValid(emailInvalidMessage);


        // firstName
        const firstNameLabel = intl.formatMessage({
          id: 'ClaimForm.firstNameLabel',
        });
        const firstNamePlaceholder = intl.formatMessage({
          id: 'ClaimForm.firstNamePlaceholder',
        });
        const firstNameRequiredMessage = intl.formatMessage({
          id: 'ClaimForm.firstNameRequired',
        });
        const firstNameRequired = validators.required(firstNameRequiredMessage);

        // lastName
        const lastNameLabel = intl.formatMessage({
          id: 'ClaimForm.lastNameLabel',
        });
        const lastNamePlaceholder = intl.formatMessage({
          id: 'ClaimForm.lastNamePlaceholder',
        });
        const lastNameRequiredMessage = intl.formatMessage({
          id: 'ClaimForm.lastNameRequired',
        });
        const lastNameRequired = validators.required(lastNameRequiredMessage);

        // BW#
        const bwLabel = intl.formatMessage({
          id: 'ClaimForm.bwLabel',
        });
        const bwPlaceholder = intl.formatMessage({
          id: 'ClaimForm.bwPlaceholder',
        });
        // const bwRequiredMessage = intl.formatMessage({
        //   id: 'ClaimForm.bwRequired',
        // });
        // const bwRequired = validators.required(bwRequiredMessage);

        // Phone Number
        const phoneLabel = intl.formatMessage({
          id: 'ClaimForm.phoneLabel',
        });
        const phonePlaceholder = intl.formatMessage({
          id: 'ClaimForm.phonePlaceholder',
        });
        const phoneRequiredMessage = intl.formatMessage({
          id: 'ClaimForm.phoneRequired',
        });
        const phoneRequired = validators.required(phoneRequiredMessage);

        // winery name
        const wineryNameLabel = intl.formatMessage({
          id: 'ClaimForm.wineryNameLabel',
        });
        const wineryNamePlaceholder = intl.formatMessage({
          id: 'ClaimForm.wineryNamePlaceholder',
        });
        const WineryNameRequiredMessage = intl.formatMessage({
          id: 'ClaimForm.wineryNameRequired',
        });
        const wineryNameRequired = validators.required(WineryNameRequiredMessage);
        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = invalid || submitInProgress;

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <div>
              <div className={css.name}>
                <FieldTextInput
                  className={css.firstNameRoot}
                  type="text"
                  id={formId ? `${formId}.fname` : 'fname'}
                  name="fname"
                  autoComplete="given-name"
                  label={firstNameLabel}
                  placeholder={firstNamePlaceholder}
                  validate={firstNameRequired}
                />
                <FieldTextInput
                  className={css.lastNameRoot}
                  type="text"
                  id={formId ? `${formId}.lname` : 'lname'}
                  name="lname"
                  autoComplete="family-name"
                  label={lastNameLabel}
                  placeholder={lastNamePlaceholder}
                  validate={lastNameRequired}
                />
              </div>
              <div className={css.name}>
                <FieldTextInput
                  className={css.firstNameRoot}
                  type="text"
                  id={formId ? `${formId}.bw` : 'bw'}
                  name="bw"
                  autoComplete="given-name"
                  label={bwLabel}
                  placeholder={bwPlaceholder}
                // validate={bwRequired}
                />
                <FieldTextInput
                  className={css.lastNameRoot}
                  type="text"
                  id={formId ? `${formId}.phone` : 'phone'}
                  name="phone"
                  autoComplete="phone-number"
                  label={phoneLabel}
                  placeholder={phonePlaceholder}
                  validate={phoneRequired}
                />
              </div>
              <FieldTextInput
                className={css.marginTop}
                type="text"
                // id={formId ? `${formId}.email` : 'email'}
                id={'winery-name'}
                name="wineryName"
                autoComplete="wineryName"
                label={wineryNameLabel}
                placeholder={wineryNamePlaceholder}
                validate={wineryNameRequired}
              />
              <FieldTextInput
                className={css.marginTop}
                type="text"
                id={formId ? `${formId}.title` : 'title'}
                name="title"
                autoComplete="title"
                label="Title"
                placeholder="Co-owner"
                validate={validators.required("Title is required")}
              />
              <FieldTextInput
                className={css.marginTop}
                type="email"
                id={formId ? `${formId}.email` : 'email'}
                name="email"
                autoComplete="email"
                label={emailLabel}
                placeholder={emailPlaceholder}
                validate={validators.composeValidators(emailRequired, emailValid, isAdmin, isOwner)}
              // disabled={true}
              />

            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: "24px 0"
              }}
            >
              <input
                type="checkbox"
                id="agreement"
                name="agreement"
                onChange={handleOnChangeIsAgreed}
                checked={isAgreed}
                style={{
                  display: 'inline-block',
                  width: 'auto',
                  marginRight: "10px"
                }}
              />
              <label
                style={{
                  fontSize: "12px",
                  marginRight: "6px"
                }}
                htmlFor="agreement"
              >
                I agree to Sommly's Terms of Service
              </label>
              <span
                style={{
                  fontSize: "12px"
                }}
              >
                <Link to="/terms-of-service">terms and conditions</Link>
              </span>
            </div>

            <div className={css.bottomWrapper}>
              <PrimaryButton
                type="submit"
                inProgress={submitInProgress}
                disabled={!isAgreed || submitDisabled}
              >
                Submit your claim request
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  )
};

CalimForm.defaultProps = { inProgress: false };

const { bool, func } = PropTypes;

CalimForm.propTypes = {
  inProgress: bool,
  intl: intlShape.isRequired,
};

export default compose(injectIntl)(CalimForm);
